import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Add } from "@mui/icons-material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  addInternationalWhyChooseus,
  fetchInternationalWhyChooseus,
  updateInternationalWhyChooseus,
  trashInternationalWhyChooseus,
} from "../../Adapters/ApiAdapter";

// const baseImage_path = "http://localhost/slraheja/sl-raheja/public/";
import { baseImage_path } from "../../variables/Variables";

const WhyChooseUsCMS = () => {
  const [entries, setEntries] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    img_icon: null,
    existing_icon: "",
  });
  const [editId, setEditId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    fetchEntries();
  }, []);

  const fetchEntries = async () => {
    try {
      const res = await fetchInternationalWhyChooseus();
      setEntries(res?.data || []);
    } catch (err) {
      console.error("Failed to fetch data", err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async () => {
    const payload = new FormData();
    payload.append("title", formData.title);

    if (formData.img_icon) payload.append("img_icon", formData.img_icon);

    try {
      let response;
      if (isEditMode) {
        response = await updateInternationalWhyChooseus(editId, payload);
      } else {
        response = await addInternationalWhyChooseus(payload);
      }

      if (response && response.status === "true") {
        toast.success(
          isEditMode ? "Updated successfully" : "Added successfully"
        );
        fetchEntries();
        handleClose();
      } else {
        toast.error("Something went wrong");
      }
    } catch (err) {
      console.error("Error submitting data", err);
    }
  };

  const handleEdit = (item) => {
    setFormData({
      title: item.title,

      img_icon: null,
      existing_icon: item.img_icon,
    });
    setEditId(item.id);
    setIsEditMode(true);
    setOpenDialog(true);
  };

  const handleTrash = async (id) => {
    try {
      const response = await trashInternationalWhyChooseus(id);
      if (response && response.status === "true") {
        toast.success("Item deleted successfully");
        fetchEntries();
      } else {
        toast.error("Failed to delete item");
      }
    } catch (err) {
      console.error("Error deleting item", err);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
    setFormData({
      title: "",
      img_icon: null,
      existing_icon: "",
    });
    setEditId(null);
    setIsEditMode(false);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "title", headerName: "Title", flex: 1 },

    {
      field: "actions",
      headerName: "Actions",
      width: 180,
      renderCell: (params) => (
        <Box>
          <Button
            variant="contained"
            size="small"
            onClick={() => handleEdit(params.row)}
          >
            Edit
          </Button>
          <Button
            variant="contained"
            size="small"
            color="error"
            sx={{ ml: 1 }}
            onClick={() => handleTrash(params.row.id)}
          >
            Trash
          </Button>
        </Box>
      ),
    },
  ];

  const renderImagePreview = () => {
    if (!formData.img_icon && !formData.existing_icon) return null;
    const imageSrc = formData.img_icon
      ? URL.createObjectURL(formData.img_icon)
      : `${baseImage_path}/${formData.existing_icon}`;

    return (
      <Box mt={2}>
        <Typography variant="subtitle2">Icon Preview:</Typography>
        <img
          src={imageSrc}
          alt="Preview"
          style={{ width: 100, height: 100, objectFit: "cover" }}
        />
      </Box>
    );
  };

  return (
    <Box p={3}>
      <ToastContainer />
      <Typography variant="h5" gutterBottom>
        Why Choose Us - CMS
      </Typography>
      <Button
        variant="contained"
        startIcon={<Add />}
        onClick={() => setOpenDialog(true)}
      >
        Add Entry
      </Button>

      <Box mt={2}>
        <DataGrid
          rows={entries}
          columns={columns}
          getRowId={(row) => row.id}
          autoHeight
        />
      </Box>

      <Dialog open={openDialog} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>{isEditMode ? "Edit" : "Add"} Entry</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="normal"
            label="Title"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
          />

          <Button variant="contained" component="label" sx={{ mt: 2 }}>
            Upload Icon
            <input
              type="file"
              hidden
              name="img_icon"
              onChange={handleInputChange}
            />
          </Button>

          {renderImagePreview()}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleClose}
            style={{ fontWeight: "bold", backgroundColor: "grey" }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            {isEditMode ? "Save" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default WhyChooseUsCMS;
